import { useEffect } from 'react';
import useSWR from 'swr';
import { usePipPlayerStore } from '@/stores/pip-player.store';
import { useSourcesStore } from '@/stores';
import { EngineService } from '@/services/engine';
import { getSourceCacheKey } from '@/constants/cache-keys';
import type { FullSource } from '@/types/source';
import { PipSourcePlayer } from '../PipSourcePlayer';
import { PipLoadingState } from './PipLoadingState';

export function PipSourceContent() {
    const sourceId = usePipPlayerStore((s) => s.sourceId);
    const getSourceById = useSourcesStore((s) => s.getSourceById);
    const addSource = useSourcesStore((s) => s.addSource);

    const cachedSource = sourceId ? getSourceById(sourceId) : undefined;

    const { data: fetchedSource, isLoading } = useSWR<FullSource>(
        sourceId && !cachedSource ? getSourceCacheKey(sourceId) : null,
        () => EngineService.getSource(sourceId!),
    );

    useEffect(() => {
        if (fetchedSource) addSource(fetchedSource);
    }, [fetchedSource, addSource]);

    const source = cachedSource ?? fetchedSource;

    if (isLoading || !source) {
        return <PipLoadingState />;
    }

    return <PipSourcePlayer source={source} />;
}
